import type { StoryMetadata } from '@/content/stories'

export const STORIES_PER_PAGE = 12

export function filterStoryLibrary(
  stories: StoryMetadata[],
  filters: { level?: string; topic?: string; query?: string }
) {
  const query = filters.query?.trim().toLocaleLowerCase() ?? ''
  return stories.filter((story) => {
    if (filters.level && story.level !== filters.level) return false
    if (filters.topic && !story.topics.includes(filters.topic)) return false
    if (!query) return true
    return [story.title_en, story.simplifiedTitle, story.traditionalTitle].some(
      (value) => value.toLocaleLowerCase().includes(query)
    )
  })
}

export function paginateStoryLibrary(stories: StoryMetadata[], page: number) {
  const totalPages = Math.max(1, Math.ceil(stories.length / STORIES_PER_PAGE))
  const currentPage = Math.min(Math.max(1, Math.trunc(page) || 1), totalPages)
  const start = (currentPage - 1) * STORIES_PER_PAGE
  return {
    currentPage,
    totalPages,
    start: stories.length ? start + 1 : 0,
    end: Math.min(start + STORIES_PER_PAGE, stories.length),
    stories: stories.slice(start, start + STORIES_PER_PAGE)
  }
}
